var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 9.5H16.8125L14.0383 6.72582C13.7336 6.42113 13.3203 6.25 12.8891 6.25H5.4375C4.09129 6.25 3 7.34129 3 8.6875V23.3125C3 24.6587 4.09129 25.75 5.4375 25.75H26.5625C27.9087 25.75 29 24.6587 29 23.3125V11.9375C29 10.5913 27.9087 9.5 26.5625 9.5ZM26.5625 23.3125H5.4375V8.6875H12.553L15.3271 11.4617C15.6318 11.7664 16.0452 11.9375 16.4763 11.9375H26.5625V23.3125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineups);
export default __webpack_public_path__ + "static/media/lineups.76242c8eb396c23934e8e80ef9373d53.svg";
export { ForwardRef as ReactComponent };